<template>
    <div id="background-container-2d">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div v-if="background !== ''" class="bc-2d-background-img" :class="background"></div>
        </transition>
        <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
            <div v-if="draught" class="dune-video">
                <div class="video-overlay" />
                <div class="video-container">
                    <video id="dune-video" muted loop>
                        <source src="@/assets/videos/draught.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "BackgroundContainer2D",
        data() {
            return {
                background: '',
                draught: false
            }
        },
        methods: {
            playDune(status) {
                switch (status) {
                    case 'show-dune-video':
                        this.draught = true;
                        setTimeout(() => {
                            let duneVideo = document.getElementById('dune-video');
                            duneVideo.play();
                        }, 500);
                        break;
                    case 'hide-dune-video':
                        this.draught = false;
                        break;
                    case 'show-dune-picture':
                        this.background = 'dune';
                        break;
                    case 'hide-dune-picture':
                        this.background = '';
                        break;
                    case 'show-child':
                        this.background = 'child';
                        break;
                    case 'hide-child':
                        this.background = '';
                        break;
                    case 'home':
                        this.background = '';
                        this.draught = false;
                        break;
                }
            }
        },
        mounted() {
        },
        created() {
            EventBus.$on('story-background', (data) => {
                this.playDune(data);
            });
            EventBus.$on('destroy-sequence', () => {
                this.sequenceAvailable = false;
            });
        }
    }
</script>

<style lang="scss" scoped>
    #background-container-2d {
        position: fixed;
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
        flex-wrap: wrap;

        .bc-2d-background-img {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            transition: opacity 800ms linear;

            &.dune {
                opacity: 1;
                background-image: url('../assets/backgrounds/dune_background.png');
            }

            &.child {

            }
        }

        .bc-2d-sequence-container {
            height: auto;
            width: auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            transform: translateY(0) translateX(0);
            transition: all 800ms linear;
            -webkit-animation: hover 10s infinite ease-in-out;
            -o-animation: hover 10s infinite ease-in-out;
            animation: hover 10s infinite ease-in-out;

            .bc-2d-s-player {
                width: 500px;
                height: 360px;
                margin-bottom: auto;
                overflow: visible;
                display: flex;
                justify-content: center;
                opacity: 0;
                margin-top: 85px;
                transition: all 800ms linear;


                & > img {
                    min-width: 640px;
                    height: auto;
                    transition: all 800ms linear;
                }

                &.drop {
                    opacity: 1;
                    height: auto;
                    transition: all 800ms linear;

                    img {
                        width: 640px;
                    }
                }

                &.human {
                    width: auto;
                    opacity: 1;
                    margin: 0;
                    height: auto;
                    transition: all 800ms linear;

                    img {
                        height: 65vh;
                        width: auto;
                        min-width: initial;
                    }
                }

                &.map {
                    opacity: 1;
                    height: auto;
                    transition: all 800ms linear;

                    img {
                        width: 1600px;
                    }
                }
            }

            .bc-2d-s-overflow {
                width: 490px;
                transition: width 500ms linear;

                &.map {
                    width: 0;
                }
            }
        }

        .dune-video {
            width: 100vw;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: visible;

            .video-overlay {
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.4);
                position: absolute;
                z-index: 2;
            }

            .video-container {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 110vw;
                height: 110vh;

                video {
                    position: fixed;
                    width: auto;
                    min-width: 100vw;
                    min-height: 100vh;
                    top: initial;
                    left: initial;
                    transform: initial;
                }
            }
        }
    }
</style>